module.exports = __webpack_public_path__ + "static/cart-image-ab9091836b7184b94589ce7494e4444f.jpg";